import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';

export const BannerContainer = styled.div`
  &.smallView {
    padding: ${fromTheme('spacing_medium')};
  }

  .actionLink {
    padding: 0;
    text-decoration: underline;
    color: #087db9; // static link color, shouldn't be based on customer config

    &:hover {
      background: transparent;
    }
  }
`;
